/**
 * Theme-aware GoGrabJob brand assets (public/social-logos).
 * Light: purple squircle mark. Dark: white outline on black squircle.
 */
export const BRAND_LOGOS = {
  mark: {
    light: '/social-logos/light/social-logo-light-mark.png',
    dark: '/social-logos/dark/social-logo-dark-mark.png',
  },
  /** @deprecated Prefer BRAND_LOGOS.mark with surface `auto` — cream tile only for legacy assets */
  markCream: {
    light: '/social-logos/light/social-logo-light-mark-cream.png',
    dark: '/social-logos/dark/social-logo-dark-mark.png',
  },
  markIconOnly: {
    light: '/social-logos/light/social-logo-mark-icon-only.png',
    dark: '/social-logos/dark/social-logo-dark-mark.png',
  },
  lockup: {
    light: '/social-logos/light/social-logo-light-lockup.png',
    dark: '/social-logos/dark/social-logo-dark-lockup.png',
  },
  stacked: {
    light: '/social-logos/light/social-logo-light-stacked.png',
    dark: '/social-logos/dark/social-logo-dark-stacked.png',
  },
} as const;

export type BrandLogoPair = (typeof BRAND_LOGOS)[keyof typeof BRAND_LOGOS];

/** Consistent logo dimensions across shell, checkout, and marketing surfaces. */
export const BRAND_LOGO_DISPLAY = {
  sidebarCollapsed: 36,
  sidebarExpandedIcon: 28,
  sidebarExpandedFont: 15,
  checkoutIcon: 32,
  checkoutFont: 16,
  mobileMenuIcon: 28,
  mobileMenuFont: 15,
  topNavIcon: 28,
  topNavFont: 14,
  marketingNavIcon: 42,
  marketingNavFont: 18,
  marketingFooterIcon: 32,
  marketingFooterFont: 16,
} as const;
